import "moment-timezone";
import React, { Component } from "react";
import { Link } from 'react-router-dom';
import PhoneNumber from '../Shared/PhoneNumber';

class ContactsTable extends Component {
  constructor(props) {
    super(props);
    this.state = { items: props.items };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.items !== prevProps.items) {
      this.setState({ items: this.props.items })
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return nextProps.items === prevState.items
      ? {}
      : { items: nextProps.items };
  }

  handleSelectChange = (event, id) => {
    const checked = event.target.checked;
    this.changeSelectedState(id, checked)
  }

  changeSelectedState = (id, checked) => {
    this.props.itemSelectStateChanged(id, checked)
  }

  handleSelectAllChange = (event) => {
    if (this.state.checkedSelectAll) {
      this.props.itemSelectAllChanged(false)
      this.setState({ checkedSelectAll: false })
    } else {
      this.props.itemSelectAllChanged(true)
      this.setState({ checkedSelectAll: true })
    }
  }

  toggleMediaControls = (id) => {
    const items = this.state.items.map((item) => {
      if (item.id === id) { item.showControls = !item.showControls }
      return item
    })
    this.setState({ items: items })
  }

  render() {
    const ContactsTable = props => {
      return (
        <tbody>
          {props.items.map(item => (
            <ContactsTableItem
              key={item.id}
              item={item}
              handleViewClick={this.handleViewClick}
            />
          ))}
        </tbody>
      );
    };

    const ContactsTableHeader = props => {
      return (
        <thead  className='dark'>
          <tr>
            <th style={{width:10}}>ID</th>
            <th>Region</th>
            <th>Email</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Telephone</th>
            <th>Deals</th>
          </tr>
        </thead>
      );
    };

    const ContactsTableItem = props => {
      const contact = props.item
      return (
        <tr key={contact.id}>
          <td data-label="ID">
            #{contact.id}
          </td>
          <td data-label="Region">{contact.region}</td>
          <td data-label="Email"><Link to={`/m1/contacts/${contact.id}`}>{contact.email || '<unknown email>'}</Link></td>
          <td data-label="First Name">{contact.first_name || '<unknown name>'}</td>
          <td data-label="Last Name">{contact.last_name || '<unknown name>'}</td>
          <td data-label="Telephone"><PhoneNumber number={contact.mobile}></PhoneNumber></td>
          <td data-label="Deals">{contact.related_deals.map((deal_id, index) => <span key={index}><Link to={`/m1/deals/${deal_id}`}>Deal #{deal_id}</Link> </span>)}</td>

        </tr>
      );
    };
    return (
      <div>
        <table
          className="table table-hover table-bordered stable-condensed responsive"
          style={{ width: "100%" }}
        >
          <ContactsTableHeader />
          <ContactsTable items={this.state.items} />
        </table>
      </div>
    );
  }
}

export default (ContactsTable)